const cards = [
  {
    title: '长风渡',
    tag: '热播古装',
    rating: '9.2',
    desc: '白敬亭宋轶主演古装商战传奇，乱世携手共渡难关',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20poster%20style%2C%20elegant%20ancient%20Chinese%20couple%20in%20flowing%20robes%2C%20warm%20golden%20and%20crimson%20color%20palette%2C%20soft%20romantic%20atmosphere%2C%20traditional%20Chinese%20architecture%20background%2C%20cinematic%20lighting%2C%20high%20quality%20drama%20promotional%20visual&width=400&height=560&seq=card-movie-01&orientation=portrait',
  },
  {
    title: '庆余年第二季',
    tag: '权谋大剧',
    rating: '9.5',
    desc: '张若昀领衔，范闲重返京都揭开惊天阴谋',
    img: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20historical%20political%20drama%20poster%2C%20male%20protagonist%20in%20dark%20elegant%20robe%2C%20dramatic%20lighting%20with%20deep%20shadows%2C%20ancient%20palace%20silhouette%20in%20background%2C%20mysterious%20and%20intense%20atmosphere%2C%20premium%20TV%20series%20visual&width=400&height=560&seq=card-movie-02&orientation=portrait',
  },
  {
    title: '与凤行',
    tag: '仙侠巨制',
    rating: '8.9',
    desc: '赵丽颖林更新再度携手，碧苍王与神君的三界虐恋',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20xianxia%20drama%20poster%2C%20ethereal%20female%20immortal%20in%20flowing%20white%20and%20red%20robes%2C%20magical%20glowing%20particles%2C%20dreamy%20celestial%20background%20with%20clouds%2C%20romantic%20fantasy%20atmosphere%2C%20high%20quality%20promotional&width=400&height=560&seq=card-movie-03&orientation=portrait',
  },
  {
    title: '狂飙',
    tag: '经典刑侦',
    rating: '9.7',
    desc: '张译张颂文飙戏，二十年黑白较量的震撼故事',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20drama%20poster%2C%20intense%20noir%20style%2C%20two%20male%20figures%20in%20dark%20suits%20facing%20off%2C%20urban%20night%20cityscape%20background%2C%20dramatic%20contrast%20lighting%2C%20gritty%20realistic%20atmosphere%2C%20premium%20series%20visual&width=400&height=560&seq=card-movie-04&orientation=portrait',
  },
  {
    title: '墨雨云间',
    tag: '复仇爽剧',
    rating: '8.7',
    desc: '吴谨言复仇归来，步步为营揭开豪门秘密',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20revenge%20drama%20poster%2C%20elegant%20female%20lead%20in%20dark%20sophisticated%20hanfu%2C%20rainy%20ancient%20courtyard%20background%2C%20mysterious%20and%20determined%20expression%2C%20deep%20emerald%20and%20black%20color%20tone%2C%20cinematic%20quality&width=400&height=560&seq=card-movie-05&orientation=portrait',
  },
  {
    title: '狐妖小红娘',
    tag: '国漫改编',
    rating: '8.4',
    desc: '杨幂龚俊演绎人妖之恋，涂山红红与东方月初',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20drama%20poster%20based%20on%20donghua%2C%20beautiful%20fox%20spirit%20female%20and%20handsome%20male%20lead%2C%20magical%20pink%20and%20gold%20color%20palette%2C%20cherry%20blossom%20and%20ancient%20Chinese%20setting%2C%20enchanting%20atmosphere&width=400&height=560&seq=card-movie-06&orientation=portrait',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">今日推荐</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">每日精选热门电视剧与电影，追剧不迷路</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {cards.map((card, idx) => (
            <div key={idx} className="group cursor-pointer">
              <div className="relative aspect-[2/3] rounded-xl overflow-hidden bg-background-200 mb-3">
                <img
                  src={card.img}
                  alt={`${card.title} - ${card.tag}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-md">
                  {card.rating}
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
                  <span className="text-background-50 text-xs leading-relaxed">{card.desc}</span>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 truncate">{card.title}</h3>
              <span className="text-xs text-foreground-500">{card.tag}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}